import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const postSeenTour = (tour) => {
    return axios.post(`${SYMFONY_API_BASE_URL}/tours/set-seen`, { tour });
};
export default postSeenTour;
